export const PaymentMethods = [
    {
        name: 'IntellectMoney',
        value: 'intellectmoney',
        method: 'СБП',
        img: '/images/paymentMethods/intellectmoney.png',
        public: true
    },
    {
        name: 'Lava',
        value: 'lava',
        method: 'СБП/Карта',
        img: '/images/paymentMethods/lava.png',
        public: true
    },
    {
        name: 'Enot',
        value: 'enot',
        method: 'СБП/Карта',
        img: '/images/paymentMethods/enot.png',
        public: true
    },
    {
        name: 'USDT',
        value: 'usdt',
        method: 'USDT',
        img: '/images/paymentMethods/usdt.png',
        public: false
    }
]